import { Stack, CircularProgress } from '@mui/material'
import type { FC } from 'react'

const InfiniteScrollLoading: FC = () => (
  <Stack direction="column" alignItems="center" paddingTop="20px">
    <span data-testid="infinite-scroll-loading">
      <CircularProgress size={20} />
    </span>
  </Stack>
)

export default InfiniteScrollLoading
